import { RemoteLoadFranchise } from "../../../data/usecase/remote-load-franchise";
import { LoadFranchise } from "../../../domain/usecase/load-franchise";
import { AxiosHttpClient } from "../../../infra/http-client/axios-http-client";

export const makeApiLoadFranchise = (): LoadFranchise => {
  const apiUrl = String(process.env.REACT_APP_BASEURL)
  const httpClient = new AxiosHttpClient<any, any>()
  return new RemoteLoadFranchise(apiUrl, httpClient)
}